module.exports = __webpack_public_path__ + "static/media/homestay_china.a58d3393.jpg";